import { JSONSchema7 } from 'json-schema';

const WmsExternalIdsSimpleTextSchema = async () => {
    let schema: JSONSchema7 = {
        title: 'WmsExternalIdsColumnSchema',
        type: 'object',
        //
        definitions: {},
    };
    //
    schema = {
        properties: {
            className: {
                type: 'string',
            },
        },
        //
        ...schema,
    };
    //
    return schema;
};

export default WmsExternalIdsSimpleTextSchema;
